module.exports = __webpack_public_path__ + "img/tokens_black.56ddd52f.svg";